import { createAuthClient } from "better-auth/react";

// Handle both Bun dev (no import.meta.env) and production builds
const env = (typeof import.meta.env !== "undefined" ? import.meta.env : {}) as Record<string, string | boolean | undefined>;

const envOrigin = String(env.PUBLIC_APP_ORIGIN ?? "").trim();
const runtimeOrigin = typeof window !== "undefined" ? window.location.origin : "";
const PROD_ORIGIN = runtimeOrigin || envOrigin || "https://et-web-app.pages.dev";

const isLocalhostOrigin = (origin: string) => {
	try {
		const u = new URL(origin);
		return u.hostname === "localhost" || u.hostname === "127.0.0.1";
	} catch {
		return origin.includes("localhost") || origin.includes("127.0.0.1");
	}
};

// Some deploy/bundle paths don't reliably set `import.meta.env.PROD`.
// Use runtime origin as source of truth: if we're not on localhost, treat as production.
const IS_PROD_RUNTIME = Boolean(env.PROD) || (Boolean(runtimeOrigin) && !isLocalhostOrigin(runtimeOrigin));

// In production, always go through the Pages Function proxy (`/api/*`).
// Fixes session cookie persistence: browser will accept cookies on same-origin responses.
const BACKEND_URL = IS_PROD_RUNTIME ? PROD_ORIGIN : "http://localhost:8787";

export const authClient = createAuthClient({
	baseURL: IS_PROD_RUNTIME ? `${BACKEND_URL}/api/auth` : `${BACKEND_URL}/auth`,
	fetchOptions: {
		credentials: "include",
	},
});

export const { signIn, signUp, signOut, useSession, getSession } = authClient;

// API client endpoints already start with `/api/...`.
// Keep base at origin to avoid accidental `/api/api/...` requests.
export const API_BASE_URL = BACKEND_URL;
